import { mapGetters } from "vuex";
import uisettings from "@/frame/theme/mixins/uisettings.js";
export default {
  data() {
    return {
      valid: true
    };
  },
  mixins: [uisettings],
  computed: {
    ...mapGetters(["getUser"]),
    ui() {
      let theme = this.uiTheme1;
      if (this.getUser == null) {
        theme = this.uiTheme1;
      } else {
        theme = this.uiTheme1;
      }
      return theme;
    }
  }
};
